import React from "react";

// Satu sumber asset logo resmi GKPY: /assets/logo-gkpy.png (ganti file ini untuk memperbarui logo di seluruh aplikasi)
export const LOGO_GKPY_SRC = `${process.env.PUBLIC_URL || ""}/assets/logo-gkpy.png`;

export const LogoGKPY = ({ className = "h-12", testId = "logo-gkpy" }) => (
  <img src={LOGO_GKPY_SRC} alt="Logo GKPY" className={`${className} w-auto object-contain select-none`} draggable={false} data-testid={testId} />
);

export default LogoGKPY;
